<template>
  <div class="challenge-visitor-intro">
    <challenge-layout
      :with-ribbon="false"
      :time-until-challenge-start="timeUntilChallengeStart"
      :challenge-header-props="{
        challengeName: challenge.name,
        shortDescription: challenge.shortDescription ?? '',
        descriptionSize: DescriptionSize.LARGE,
      }"
    >
      <template v-slot:cards>
        <card>
          <div>
            <riseup-button
              class="margin-top-ml"
              title="הרשמה ללקוחות רייזאפ"
              :action="redirectToLogin"
              :size="'small'"
            />
            <or-separator />
            <riseup-button
              title="הרשמה כאורח.ת"
              :action="redirectToSignup"
              :size="'small'"
              :variant="'secondary'"
            />
            <div class="ri-body margin-vertical-ml" />
          </div>
        </card>
      </template>
      <template v-slot:info>
        <div class="description margin-top-l">
          <img
            class="image-container"
            :src="blueStarImage"
          >
          <div class="margin-top-s ri-bold-body">
            ההרשמה לאתגר בחינם!
          </div>
          <div class="margin-top-s ri-body">
            לאחר ההרשמה נשלח לך הודעות ווטסאפ שיעזרו לך להשלים את המשימה בקלות ולהתחיל לחסוך!
          </div>
        </div>
      </template>
    </challenge-layout>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton/RiseupButton.vue';
import { useRoute, useRouter } from 'vue-router';
import { useRouteParams } from '@vueuse/router';
import OrSeparator from '@riseupil/base-ui/src/components/OrSeparator.vue';
import ChallengeLayout from '../../layouts/ChallengeLayout.vue';
import { useChallengeStore } from '../../stores/challenge';
import Segment from '../../Segment';
import blueStarImage from '../../assets/blue-star.svg';
import { DescriptionSize } from '../ChallengeHeader/DescriptionSize';

const route = useRoute();
const router = useRouter();

const challengeId = useRouteParams<string>('challengeId');
const challengeStore = useChallengeStore();
await challengeStore.initForVisitor(challengeId.value);
const { challenge, timeUntilChallengeStart } = storeToRefs(challengeStore);
Segment.trackUserGot('Intro_Shown');

const redirectToLogin = () => {
  Segment.trackUserInteraction('Intro_LoginClicked');
  router.push({ path: '/login', query: route.query });
};
const redirectToSignup = () => {
  Segment.trackUserInteraction('Intro_SignupClicked');
  router.push({ path: '/signup', query: route.query });
};
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/mixins';
@import '@riseupil/base-ui/src/scss/spacings';

.challenge-visitor-intro {
  @include white-page-frame;
  height: 100%;
  flex-grow: 1;

  .card {
    background-color: $riseup_white;
    color: $riseup_black;
  }

  .description {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    .image-container {
      width: 32px;
      height: 32px;
    }
  }
}
</style>
